(function () {
  const DRAWER_ID = "cart-edit-line-item-drawer";

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  document.addEventListener(
    "click",
    function (event) {
      const trigger = event.target.closest("[data-edit-line-item]");
      if (!trigger) return;
      const drawer = getDrawer();
      if (!drawer) return;

      const handle = trigger.dataset.productHandle;
      const variantId = trigger.dataset.variantId;
      drawer.dataset.lineKey = trigger.dataset.lineKey || "";
      drawer.dataset.lineQuantity = trigger.dataset.lineQuantity || "1";
      drawer.dataset.lineVariantId = variantId || "";

      // Bypass QuickBuyDrawer's built-in fetcher (it looks for quick-buy-content);
      // we own the content lifecycle here so we can use jkl-quick-buy-content.
      drawer._hasLoaded = true;
      drawer.replaceChildren();
      loadDrawerContent(drawer, handle, variantId);
    },
    true,
  );

  function relabelSubmitButton(drawer) {
    const label = drawer.dataset.updateLabel;
    if (!label) return;
    const submit = drawer.querySelector(
      '.buy-buttons button[type="submit"], button[type="submit"]',
    );
    if (!submit) return;
    const span = submit.querySelector("span") || submit;
    span.textContent = label;
  }

  async function loadDrawerContent(drawer, handle, variantId) {
    if (!handle) return;
    drawer.setAttribute("aria-busy", "true");
    drawer.replaceChildren();

    let url = window.Shopify.routes.root + "products/" + handle;
    if (variantId) url += "?variant=" + variantId;

    // When the inline edit content can't be loaded (product/variant
    // unpublished or unavailable in this market, or a network failure),
    // fall back to the product page so the user is never left staring at an
    // empty drawer. Mirrors the non-modal edit link in jkl-line-item.liquid.
    try {
      const res = await fetch(url);
      if (!res.ok) {
        window.location.assign(url);
        return;
      }
      const html = await res.text();
      const template = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("jkl-quick-buy-content");
      if (!template) {
        window.location.assign(url);
        return;
      }
      Array.from(template.content.querySelectorAll("noscript")).forEach((n) =>
        n.remove(),
      );
      drawer.replaceChildren(template.content.cloneNode(true));
      if (window.Shopify && window.Shopify.PaymentButton) {
        window.Shopify.PaymentButton.init();
      }
      relabelSubmitButton(drawer);
    } catch (e) {
      window.location.assign(url);
    } finally {
      drawer.removeAttribute("aria-busy");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.addEventListener("dialog:after-show", function () {
      relabelSubmitButton(drawer);
    });

    drawer.addEventListener("click", function (event) {
      const link = event.target.closest(".product-info__product-picker a");
      if (!link || !drawer.contains(link)) return;
      const href = link.getAttribute("href") || "";
      const match = href.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      event.preventDefault();
      const newHandle = match[1];
      drawer.setAttribute("handle", newHandle);
      loadDrawerContent(drawer, newHandle);
    });

    drawer.addEventListener(
      "submit",
      async function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const lineKey = drawer.dataset.lineKey;
        const lineQuantity = drawer.dataset.lineQuantity || "1";
        const oldVariantId = drawer.dataset.lineVariantId || "";
        if (!lineKey) {
          window.location.reload();
          return;
        }

        const submitButtons = Array.from(form.elements).filter(
          (el) => el.type === "submit",
        );
        submitButtons.forEach((b) => b.setAttribute("aria-busy", "true"));

        const formData = new FormData(form);
        formData.set("quantity", lineQuantity);
        const newVariantId = String(formData.get("id") || "");

        const reportError = async (res) => {
          const err = await res.json().catch(() => ({}));
          submitButtons.forEach((b) => b.removeAttribute("aria-busy"));
          form.dispatchEvent(
            new CustomEvent("cart:error", {
              bubbles: true,
              detail: { error: err.description || err.message || "" },
            }),
          );
        };

        try {
          if (newVariantId && newVariantId === oldVariantId) {
            // Same variant: update properties/quantity in place to avoid
            // the cart/add merge that would double then zero out the line.
            const properties = {};
            for (const [key, value] of formData.entries()) {
              if (key.startsWith("properties[") && key.endsWith("]")) {
                properties[key.slice("properties[".length, -1)] = value;
              }
            }
            const sellingPlan = formData.get("selling_plan");
            const body = {
              id: lineKey,
              quantity: parseInt(lineQuantity, 10) || 1,
              properties: properties,
            };
            if (sellingPlan) body.selling_plan = sellingPlan;

            const changeRes = await fetch(
              window.Shopify.routes.root + "cart/change.js",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify(body),
              },
            );
            if (!changeRes.ok) {
              await reportError(changeRes);
              return;
            }
          } else {
            // Different variant: remove the original line first so the new
            // add can never merge into the line we're about to delete.
            const removeRes = await fetch(
              window.Shopify.routes.root + "cart/change.js",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
                body: JSON.stringify({ id: lineKey, quantity: 0 }),
              },
            );
            if (!removeRes.ok) {
              await reportError(removeRes);
              return;
            }

            const addRes = await fetch(
              window.Shopify.routes.root + "cart/add.js",
              {
                method: "POST",
                body: formData,
                headers: { "X-Requested-With": "XMLHttpRequest" },
              },
            );
            if (!addRes.ok) {
              await reportError(addRes);
              return;
            }
          }

          window.location.reload();
        } catch {
          submitButtons.forEach((b) => b.removeAttribute("aria-busy"));
        }
      },
      true,
    );
  });
})();
